<template>
  <v-dialog v-model="value" persistent scrollable max-width="655px">
    <v-card class="pa-0">
      <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
        <v-spacer></v-spacer>
        <span class="mdlHeadForms">{{ sTitle }}</span>
        <v-spacer></v-spacer>
        <v-btn  color="btncolor-dark" @click="CloseDialog()" icon small dark outlined>
          <v-icon size="15px">fa fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="max-height: 80vh;" class="pa-1">
        <v-container fluid>
          <v-row class="no-gutters">
            <div class="my-2">
              <span class="text-medium text-primary font-size-1">{{$store.state.jsIdioma.oEquivalencias.ttlInformacionPrincipal}}</span>
            </div>
            <v-container class="cont-shadown-rounded pa-1" fluid>
              <v-row class="no-gutters">
                <v-col cols="12" class="text-center">
                  <div class="item-dia-seleccionado">
                    <h2><v-icon>mdi-calendar</v-icon> {{sDia}}</h2>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <div class="mx-auto">
          <v-btn color="btncolor" dark class="mx-1" @click="CloseDialog">{{$store.state.jsIdioma.oEquivalencias.btnCancelar}}</v-btn>
          <v-btn color="btncolor" dark class="mx-1" @click="onGuardar">{{$store.state.jsIdioma.oEquivalencias.btnGuardar}}</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axiosServices from '@/services/axiosServices.js'
export default {
  name:'FormAgregarDiaFestivo',
  components: { },
  props:{
    value: {
      type: Boolean,
      default: false
    },
    sDia:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      sTitle: 'Dia Festivo',
    }
  },
  mounted() {
  },
  methods: {
    CloseDialog(){
      this.$emit('input', false)
    },
   async onGuardar (){
      const  oBody= {
        feriado: this.sDia
      }
      const oRespuesta = await axiosServices.postConfiguration('pqr/festivo', oBody, true)
      oRespuesta
      this.$emit('guardado')
      this.CloseDialog()
    }
  },
  computed: {
  },
  watch:{
  }

}
</script>
<style lang="scss" scoped>
.mdlHeadForms{
  font-size: 0.9em;
}
.item-dia-seleccionado{
  h2{
    font-size: 1.2em;
  }
}
</style>
